import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ThreeDots } from "react-loader-spinner";

import { TextInputField, DropDownField, Button } from "../../../helpers";
import { validateInputs } from "../../../utils";
import { pettyCashRequestDetails, PettyCashRequestSchema} from "../../../validation/pettyCashValidation";

import { postPettyCashRequest } from "../../../services/api/pettyCash";
import { raiseToast } from "../../../services/redux/reducers/toast/toast";
import { getCompanyBillAddrs } from "../../../services/api/companyBillAddr";
import _ from "lodash";
import Loading from "../../../common/Loading";
import { fetchStates } from "../../../services/redux/reducers/commonThunk";


const RequestPettyCash = (props) =>{
    const { pettyCashAccount, getPettyCashData, setVisiblePettyCashRequest , pettyCashBalance} = props

    const [formErrors, setFormErrors] = useState({})
    const [requestDetails,setRequestDetails] = useState(pettyCashRequestDetails)
    const [isLoading, setIsLoading] = useState(false)

    const [procmartCompanyBillAddrs, setProcmartCompanyBillAddrs] = useState([])
    const [statesData, setStatesData] = useState([])
    
	const usersData = useSelector(state => state.userDetails)
	const pmCompanyDetails = useSelector((state) => state.userDetails.PMCompanyDetails)
	const statesDetails = useSelector((state) => state.common.states)

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(fetchStates())
    }, [])

    useEffect(() => {
		getProcmartStates()
	}, [statesDetails])


    const getProcmartStates = async () => {
        const allPrimaryBillAddrId =  _.map(pmCompanyDetails.companyBranches, 'primaryBillAddrId')
        const response = await getCompanyBillAddrs({ billAddrIds: allPrimaryBillAddrId, paginator: false })

        if(response.failure){
            dispatch(raiseToast({severity:'error', summary: 'Billing Address', detail: response.data.error , life: 3000}))
        }
        setProcmartCompanyBillAddrs(response.data.data)

        const allStateIds = _.map(response.data.data, 'stateId')
        const filteredStates = _.filter(statesDetails, (state) => allStateIds.includes(state.stateId))

        setStatesData(filteredStates)
    }
    
    const handleRequestClick = async () => {
        const validation_res = await validateInputs(PettyCashRequestSchema, requestDetails)
        const activeRoleId = usersData?.activeRoleId
        const relatedUserCompany = usersData?.rolesList?.find(eachRole => eachRole?.userRoleId === activeRoleId)
        
        if (validation_res){
            if (validation_res.error){
                setFormErrors(validation_res.error)
            } else {
                setFormErrors({})
                const pettyCashData = {
                    data: {
                        PMState : requestDetails?.PMState,
                        entryType : "REQUEST",
                        amount : requestDetails.amount,
                        transactionDate : new Date(),
                        statusId : 7,
                        documentType : null,
                        // voucherNo: 1,
                        pettyCashAccount : pettyCashAccount?.pettyCashAccountId,
                        createdBy: usersData?.userId,
                        updatedBy: usersData?.userId,
                        pmBranchId : relatedUserCompany?.branchId,
                        pmCompanyId: pmCompanyDetails.pmCompanyId
                    }
                }
                console.log("request", pettyCashData)

                if(pettyCashBalance?.approvedBalance >= 20000){
                    dispatch(raiseToast({severity:'error', summary: 'PettyCash Request', detail:'Request can not be raised. Current balance should be less than \u20B9 20000.', life: 3000}))
                }else{
                    if (window.confirm("Are you sure you want to continue..?")){
                        setIsLoading(true)
                        const response = await postPettyCashRequest(pettyCashData)
                        if (response?.failure){
                            dispatch(raiseToast({severity:'error', summary: response.data.error, detail:'Petty Cash Request is Not Inserted', life: 3000}))
                        } else {
                            getPettyCashData()
                            setVisiblePettyCashRequest(false)
                            dispatch(raiseToast({severity:'success', detail:'Petty Cash Request is Inserted', life: 3000}))
                        }
                        setRequestDetails(pettyCashRequestDetails)
                        setIsLoading(false)
                    }
                }
            }
        }    
    }

    const handleChange = async (e) => {
        console.log(e.target.name, e.target.value)
        setRequestDetails(prevState => ({...prevState, [e.target.name] : e.target.value}))
    }

    return(
        <div>
            <div className="grid">
                <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                    <DropDownField name="PMState" optionLabel="stateName" optionValue="stateId" options={statesData} labelText="Procmart State" errorMessage={formErrors.PMState} value={requestDetails.PMState} onChange={(e) => handleChange(e)}/>
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0" >
                    <TextInputField name="amount" labelText='Amount' placeholder="Amount" value={requestDetails.amount} errorMessage={formErrors.amount} onChange={(e) => handleChange(e)}/>
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-6 lg:mb-0">
                    <TextInputField name="prodDesc" labelText='Description' placeholder="Description" value={requestDetails.prodDesc} errorMessage={formErrors.prodDesc} onChange={(e) => handleChange(e)}/>
                </div>
            </div>
            {/* <div className="flex justify-content-center h-full">
                <ThreeDots height="50" width="50" radius="5"color="#00baac" ariaLabel="three-dots-loading" visible={isLoading} /> 
            </div> */}
            <Loading visible={isLoading} />
            <div className="flex justify-content-end mt-4">
                <Button  className="h-2rem  p-2" label="Request" onClick={handleRequestClick}/>   
            </div>
        </div>
    )
}
export default RequestPettyCash;